export default __webpack_public_path__ + "static/All about Mattresses for a Good Night Sleep-4cbf58830aa591d7b6e6d05347ad62fb.jpg";